import { render, staticRenderFns } from "./foreign-cultural.vue?vue&type=template&id=15353690&scoped=true"
import script from "./foreign-cultural.vue?vue&type=script&lang=js"
export * from "./foreign-cultural.vue?vue&type=script&lang=js"
import style0 from "./foreign-cultural.vue?vue&type=style&index=0&id=15353690&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15353690",
  null
  
)

export default component.exports